"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _PaymentTrustMarkFooterProptypes = _interopRequireDefault(require("./PaymentTrustMarkFooterProptypes.proptypes"));
var _constant = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var sharedMargin = (0, _styledComponents.css)(["margin-right:5px;"]);
var LegalCopyWrapper = _styledComponents.default.div.withConfig({
  displayName: "PaymentTrustMarkFooter__LegalCopyWrapper",
  componentId: "sc-v9aexy-0"
})(["border-top:1px solid ", ";background-color:#f8f8f8;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.greyLight;
});
LegalCopyWrapper.displayName = 'LegalCopyWrapper';
var LegalCopyContainer = _styledComponents.default.div.withConfig({
  displayName: "PaymentTrustMarkFooter__LegalCopyContainer",
  componentId: "sc-v9aexy-1"
})(["display:flex;flex-direction:row;background-color:#f8f8f8;max-width:1224px;padding:10px;margin:0 auto;"]);
LegalCopyContainer.displayName = 'LegalCopyContainer';
var LegalCopyLeftPaneContainer = _styledComponents.default.div.withConfig({
  displayName: "PaymentTrustMarkFooter__LegalCopyLeftPaneContainer",
  componentId: "sc-v9aexy-2"
})(["align-self:center;position:relative;width:50%;"]);
LegalCopyLeftPaneContainer.displayName = 'LegalCopyLeftPaneContainer';
var SecureMessage = _styledComponents.default.span.withConfig({
  displayName: "PaymentTrustMarkFooter__SecureMessage",
  componentId: "sc-v9aexy-3"
})(["position:absolute;top:3px;font-weight:", ";font-family:", ";font-size:", ";color:", ";margin-left:5px;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeight.normal;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily.default;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize.small;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.greyDark;
});
SecureMessage.displayName = 'SecureMessage';
var LegalCopyRightPaneContainer = _styledComponents.default.div.withConfig({
  displayName: "PaymentTrustMarkFooter__LegalCopyRightPaneContainer",
  componentId: "sc-v9aexy-4"
})(["margin-left:auto;padding-right:20px;"]);
var PciImage = _styledComponents.default.img.withConfig({
  displayName: "PaymentTrustMarkFooter__PciImage",
  componentId: "sc-v9aexy-5"
})(["", ""], sharedMargin);
PciImage.displayName = 'PciImage';
var MastercardImage = _styledComponents.default.img.withConfig({
  displayName: "PaymentTrustMarkFooter__MastercardImage",
  componentId: "sc-v9aexy-6"
})(["", ""], sharedMargin);
MastercardImage.displayName = 'MastercardImage';
var VisaImage = _styledComponents.default.img.withConfig({
  displayName: "PaymentTrustMarkFooter__VisaImage",
  componentId: "sc-v9aexy-7"
})(["", ""], sharedMargin);
VisaImage.displayName = 'VisaImage';
var PaymentTrustMarkFooter = function PaymentTrustMarkFooter(props) {
  var theme = props.theme,
    pciLabel = props.pciLabel,
    accessible = props.accessible,
    toggles = props.toggles;

  // use default english message if not label passed
  var displayLabel = pciLabel || _constant.DEFAULT_LABEL;
  var tabIndex = !accessible ? '-1' : '0';
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(LegalCopyWrapper, null, /*#__PURE__*/_react.default.createElement(LegalCopyContainer, null, /*#__PURE__*/_react.default.createElement(LegalCopyLeftPaneContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: _constant.ICON_NAME.SHIELD
  }), /*#__PURE__*/_react.default.createElement(SecureMessage, {
    tabIndex: tabIndex
  }, displayLabel)), /*#__PURE__*/_react.default.createElement(LegalCopyRightPaneContainer, null, toggles.showPci && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: _constant.ICON_NAME.PCI
  }), toggles.showVisa && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: _constant.ICON_NAME.VISA
  }), toggles.showMc && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: _constant.ICON_NAME.MASTERCARD
  }), toggles.showJcb && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: _constant.ICON_NAME.JCB
  })))));
};
PaymentTrustMarkFooter.propTypes = _PaymentTrustMarkFooterProptypes.default.PropTypes;
PaymentTrustMarkFooter.defaultProps = _PaymentTrustMarkFooterProptypes.default.DefaultProps;
var _default = PaymentTrustMarkFooter;
exports.default = _default;